import { List, Record } from 'immutable';
const ThreadUpdate = Record({
  audit: null,
  members: List()
}, 'ThreadUpdate');
export default ThreadUpdate;